import React, { FC } from 'react'
import { Divider, Image, Layout, Row, Space } from 'antd'
import dayjs from 'dayjs'
import { HeaderText } from './common/HeaderText';
const { TwitchEmbed } = require('react-twitch-embed')

const { Header, Content } = Layout;

export interface InfoProp {
    tournament: any
}

export const Info: FC<InfoProp> = (props) => {
    return (
        <Layout>
            <Header className="contentHeader">
                <Row justify="space-between">
                    <HeaderText title={props.tournament?.name} />
                    <HeaderText title={dayjs(props.tournament?.date).format("dddd, MMMM DD YYYY")} />
                </Row>
            </Header>
            <Content className="mainContent" style={{ overflow: "visible" }}>
                <Space direction="horizontal" style={{ width: '100%', justifyContent: "center" }}>
                    <Image src={process.env.PUBLIC_URL + "/assets/meme-19-poster.png"} preview={false} className="posterSetting" />
                </Space>
                <Divider />
            </Content>
        </Layout>
    )
}